export default __webpack_public_path__ + "static/media/logolp.563bdbe3.png";